import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wisdom-media',
  templateUrl: './wisdom-media.component.html',
  styleUrls: ['./wisdom-media.component.css']
})
export class WisdomMediaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
